import React from 'react';
import MatchStatisticsScrollable from '../../MatchStatisticsScrollable';
import i18n from '../../../../../common/i18n';
import { WidgetWrapper } from '../../../sportradar-widgets/WidgetWrapper';
import { SrWidgetGeneralStatistics } from '../../../sportradar-widgets/SrWidgetGeneralStatistics';
import { SrWidgetMatchStatistics } from '../../../sportradar-widgets/SrWidgetMatchStatistics';

function BetradarMTStatisticsExtended({ matchId, sportId }) {
    const sportsWithoutMatchStatistics = [3, 7, 11, 13, 61, 68, 85, 88, 89, 101];
    const showMatchStatistics = !sportsWithoutMatchStatistics.includes(parseInt(sportId));
    return (
        <MatchStatisticsScrollable>
            <WidgetWrapper title={showMatchStatistics && i18n('betradarMT.statisticTab.main')}>
                <SrWidgetGeneralStatistics matchId={matchId} />
            </WidgetWrapper>
            {showMatchStatistics && (
                <WidgetWrapper title={i18n('betradarMT.statisticTab.graph')}>
                    <SrWidgetMatchStatistics matchId={matchId} />
                </WidgetWrapper>
            )}
        </MatchStatisticsScrollable>
    );
}

export default BetradarMTStatisticsExtended;
